import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export function UnlinkedPackageWarning({ variant, message }) {
  if (variant === "info") {
    return (
      <MDBox
        mb={2}
        p={2}
        display="flex"
        alignItems="flex-start"
        gap={1}
        sx={{
          backgroundColor: "#e2e3e5",
          border: "1px solid #d6d8db",
          borderRadius: "8px",
          color: "#383d41",
        }}
      >
        <Icon fontSize="small" sx={{ mt: 0.25, color: "#6c757d" }}>
          info
        </Icon>
        <MDTypography variant="caption" color="inherit" fontWeight="medium">
          {message}{" "}
        </MDTypography>
      </MDBox>
    );
  }

  return (
    <MDBox
      mb={3}
      p={2}
      display="flex"
      alignItems="center"
      gap={1.5}
      sx={{
        backgroundColor: "#fff3cd",
        border: "1px solid #ffeeba",
        borderRadius: "12px",
        color: "#856404",
      }}
    >
      <Icon fontSize="medium" sx={{ color: "#856404" }}>
        warning
      </Icon>
      <MDTypography variant="button" fontWeight="medium" color="inherit">
        {message}
      </MDTypography>
    </MDBox>
  );
}

UnlinkedPackageWarning.defaultProps = {
  variant: "warning",
};

UnlinkedPackageWarning.propTypes = {
  variant: PropTypes.oneOf(["warning", "info"]),
  message: PropTypes.string,
};
